// extracted by mini-css-extract-plugin
module.exports = {"icon":"StudyIcon_icon__1aSgS","sm":"StudyIcon_sm__DkaiD","lg":"StudyIcon_lg__m871h"};